/**
 * ÊVO Standard™ — Scroll Animations & Parallax
 * - Slower, more cinematic reveals (1.6s)
 * - Footer excluded
 * - Hero excluded from parallax
 * - Mobile: no parallax
 */

(function () {
  'use strict';

  var PARALLAX_BREAKPOINT = 768;
  var PARALLAX_SPEED = 0.12;
  var STAGGER_MS = 180;  // slower stagger between siblings

  var PARALLAX_SKIP_SECTIONS = '.hero, .hero-section, [class*="hero"]';

  var PARALLAX_SELECTORS = [
    '.academy-band__bg',
    '.consultation-band__bg',
    '.closing-cta__bg',
    '[class*="-band"] [class*="__bg"]',
    '[class*="__band"] [class*="__bg"]',
    '.founder__image img',
    '.founder__photo',
    '[class*="founder__image"]',
    '.bento-card__image',
    '.bento-card img',
    '.results-slide img'
  ].join(', ');

  var TEXT_SELECTORS = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p',
    'td', 'th',
    '.btn', '.button', 'a.btn', 'button.btn',
    '.evo-label', '.evo-heading', '.evo-body', '.evo-cta',
    '.section-heading', '.section-label', '.section-subheading',
    'blockquote', 'figcaption',
    'span',
    '[class*="__title"]', '[class*="__heading"]', '[class*="__label"]',
    '[class*="__text"]', '[class*="__body"]', '[class*="__cta"]',
    '[class*="__btn"]', '[class*="__description"]', '[class*="__caption"]',
    '[class*="__name"]', '[class*="__author"]', '[class*="__quote"]',
    '[class*="__philosophy"]', '[class*="philosophy"]',
    '[class*="__founder"]', '[class*="founder"]'
  ].join(', ');

  var HARD_SKIP = [
    '.site-header', '.site-nav', 'nav', 'header',
    '.shopify-section-header', '.evo-no-anim',
    'footer', '.site-footer', '.footer', '[class*="footer"]'
  ].join(', ');

  // ─── STYLES ─────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('evo-anim-styles')) return;
    var s = document.createElement('style');
    s.id = 'evo-anim-styles';
    s.textContent = [
      '.evo-reveal {',
      '  opacity: 0;',
      '  transform: translateY(40px);',
      '  transition: opacity 1.6s cubic-bezier(0.23,1,0.32,1), transform 1.6s cubic-bezier(0.23,1,0.32,1);',
      '}',
      '.evo-reveal.evo-revealed {',
      '  opacity: 1 !important;',
      '  transform: translateY(0) !important;',
      '}',
      '.academy-band, .consultation-band, .closing-cta, [class*="-band"], [class*="__band"] {',
      '  overflow: hidden !important;',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  // ─── SCROLL REVEAL ──────────────────────────────────────────────────────────

  function initReveal() {
    var all = document.querySelectorAll(TEXT_SELECTORS);
    var tagged = new Set();

    all.forEach(function (el) {
      if (tagged.has(el)) return;
      try { if (el.closest(HARD_SKIP)) return; } catch(e) {}
      if (el.parentElement && el.parentElement.classList.contains('evo-reveal')) return;
      if (!el.textContent.trim() && !el.querySelector('img')) return;
      tagged.add(el);
      el.classList.add('evo-reveal');
    });

    // Stagger direct siblings
    var parents = new Set();
    document.querySelectorAll('.evo-reveal').forEach(function (el) {
      if (el.parentElement) parents.add(el.parentElement);
    });
    parents.forEach(function (parent) {
      var kids = Array.from(parent.querySelectorAll(':scope > .evo-reveal'));
      if (kids.length > 1) {
        kids.forEach(function (kid, i) {
          kid.style.transitionDelay = (i * STAGGER_MS) + 'ms';
        });
      }
    });

    // Immediately reveal anything already in viewport on load
    document.querySelectorAll('.evo-reveal').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('evo-revealed');
      }
    });

    // Observer — keeps watching so animations replay on scroll up too
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('evo-revealed');
          } else {
            entry.target.classList.remove('evo-revealed');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

      document.querySelectorAll('.evo-reveal').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      function checkScroll() {
        document.querySelectorAll('.evo-reveal').forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            el.classList.add('evo-revealed');
          } else {
            el.classList.remove('evo-revealed');
          }
        });
      }
      window.addEventListener('scroll', checkScroll, { passive: true });
      checkScroll();
    }
  }

  // ─── PARALLAX ───────────────────────────────────────────────────────────────

  function initParallax() {
    if (window.innerWidth < PARALLAX_BREAKPOINT) return;

    var els = Array.from(document.querySelectorAll(PARALLAX_SELECTORS)).filter(function (el) {
      try { return !el.closest(PARALLAX_SKIP_SECTIONS); } catch(e) { return true; }
    });

    if (!els.length) return;

    function tick() {
      if (window.innerWidth < PARALLAX_BREAKPOINT) {
        els.forEach(function (el) { el.style.transform = ''; });
        return;
      }
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var center = rect.top + rect.height / 2;
        var offset = (center - window.innerHeight / 2) * PARALLAX_SPEED;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    }

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth < PARALLAX_BREAKPOINT) {
        els.forEach(function (el) { el.style.transform = ''; });
      }
    }, { passive: true });
    tick();
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();